import { render, staticRenderFns } from "./LineRegistButton.vue?vue&type=template&id=31b2e695&"
import script from "./LineRegistButton.vue?vue&type=script&lang=ts&"
export * from "./LineRegistButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports